import React from 'react';
import { BaseContent, Button, Heading, Skeleton, useMediaQueryContext, useSlider, } from '@fourthwall/components';
import { useWebViewBridge } from '@fourthwall/webview-bridge';
import { useOffersTotal } from '@hooks';
import { routing } from '@utils/routing';
import { useCreateProduct } from '../../../Product/hooks/useCreateProduct';
import { useCampaignStatus } from '../../Recommendations/hooks/useCampaignStatus';
import { Bonus } from '../components/Bonus/Bonus';
import { Pills } from '../components/Pills';
import { Slider } from '../components/Slider';
import { useHomeProducts } from '../useHomeProducts';
import * as S from './styled';
const getCopyProps = (count) => {
    // no products
    if (count === 0 || count === undefined) {
        return {
            title: 'Create your first product',
            subtitle: 'Design a new product or list something you own.',
        };
    }
    // 1 to 4 products created
    if (count <= 4) {
        return {
            title: 'Create another product',
            subtitle: 'We recommend giving supporters 3-5 options to choose from.',
        };
    }
    // > 4 products created
    return {
        title: 'Create another product',
        subtitle: 'Give supporters more options to choose from.',
    };
};
export const HomeProductsSlider = () => {
    const offersTotal = useOffersTotal();
    const mediaQuery = useMediaQueryContext();
    const { openCreateProductModal } = useCreateProduct();
    const homeProducts = useHomeProducts();
    const { methods, isWebView } = useWebViewBridge();
    const slider = useSlider();
    const { activeIncentives } = useCampaignStatus();
    const incentive = activeIncentives.find((i) => i.recommendationId === 'createProduct');
    // if (!offersTotal) return null
    const count = offersTotal?.all;
    const renderButtons = () => {
        return (React.createElement(S.ButtonGroup, null,
            React.createElement(Button, { label: "Browse all products", appearance: "secondary", size: "xsmall", fullWidth: true, ...(isWebView
                    ? {
                        onClick: async () => methods.openMobilePage?.({
                            mobile_path: 'product_catalog',
                            url: routing.productCatalog.self,
                        }),
                    }
                    : { href: routing.productCatalog.self }), analytics: "browseAllProducts" }),
            React.createElement(Button, { label: "Create product", appearance: "primary", size: "xsmall", fullWidth: true, onClick: async () => {
                    if (isWebView) {
                        await methods.openMobilePage?.({
                            mobile_path: 'product_catalog',
                            url: routing.productCatalog.self,
                        });
                    }
                    else {
                        openCreateProductModal();
                    }
                }, analytics: "createANewProduct" })));
    };
    if (!homeProducts || homeProducts?.isLoading) {
        return React.createElement(RecommendationSkeleton, null);
    }
    if (!homeProducts) {
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(S.Header, null,
            React.createElement("div", null, mediaQuery.tablet ? (React.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: '16px' } },
                React.createElement(Heading, { type: "h4", weight: "semibold", asTag: "h3" }, getCopyProps(count).title),
                incentive && React.createElement(Bonus, { bonus: incentive.incentive.bonus.value }))) : (React.createElement(BaseContent, null,
                React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', gap: '16px' } },
                    React.createElement("strong", null,
                        " ",
                        getCopyProps(count).title),
                    incentive && React.createElement(Bonus, { bonus: incentive.incentive.bonus.value }))))),
            !homeProducts?.categories.visible && renderButtons()),
        React.createElement("div", null, homeProducts?.categories && (React.createElement("div", { ...slider.getContainerProps() },
            React.createElement(S.SliderHeader, { "$marginTop": true },
                homeProducts.categories && homeProducts.categories.visible && mediaQuery.tablet && (React.createElement(Pills, null, homeProducts.categories.options.map((option) => {
                    return (React.createElement(Pills.Pill, { key: option.value, active: option.value === homeProducts.categories.value, label: option.label, onClick: () => homeProducts?.categories.onChange(option.value) }));
                }))),
                homeProducts.categories.visible && renderButtons()),
            React.createElement(Slider, { products: homeProducts.products, activeCategory: homeProducts.activeCategory, slider: slider, onProductClick: homeProducts.onProductClick }))))));
};
const RecommendationSkeleton = () => {
    const mediaQuery = useMediaQueryContext();
    const skeletonCount = (() => {
        if (mediaQuery.tablet)
            return 5;
        return 2;
    })();
    return (React.createElement(S.Container, null,
        React.createElement(S.Header, null,
            React.createElement("div", null, mediaQuery.tablet ? (React.createElement(Skeleton.Shape, { height: 32, width: 250 })) : (React.createElement(Skeleton.Shape, { height: 24, width: 200 }))),
            React.createElement(S.ButtonGroup, null,
                React.createElement(Skeleton.Shape, { height: 36, width: "100%" }),
                React.createElement(Skeleton.Shape, { height: 36, width: "100%" }))),
        React.createElement(S.SkeletonSlider, null, [...Array(skeletonCount)].map((_, index) => (React.createElement(S.SkeletonCard, { key: index },
            React.createElement(S.SkeletonProductImage, null),
            React.createElement(S.SkeletonProductInfo, null,
                React.createElement(Skeleton.Shape, { height: 20, width: "80%" }),
                React.createElement(Skeleton.Shape, { height: 16, width: "40%" }))))))));
};
